import Vue from "vue";
import BzbsApi from "@/core/Http/BzbsApi.js";
import { map } from "rxjs/operators";

/**
 * @method apiGetProductList
 * @method apiGetProductMaster
 */

export default {
    config: function() {
        return Vue.bzbsConfig;
    },

    /**
     * Return Product Point Detail.
     */
    apiGetProductPoint: function() {
        // var currentTime = new Date().getTime() / 1000;
        // ?time=${currentTime}
        var url = `${this.config().bzbsBlobUrl}/config/bioderma/productPointDetail/ProductPoint.json`;
        return BzbsApi.connectBzbsGetBlob(url).pipe(map(res => res.data));
    },

    /**
     * Return Product Detail.
     */
     apiGetProductMaster: function() {
        // var currentTime = new Date().getTime() / 1000;
        // ?time=${currentTime}
        var url = `${this.config().bzbsBlobUrl}/config/bioderma/productMaster/MasterProduct.json`;
        return BzbsApi.connectBzbsGetBlob(url).pipe(map(res => res.data));
    },
};
